import React, { useContext } from "react";

import styled from "styled-components/macro";

import { BoardContext } from "./BoardContext";
import { TitleCellWrapper } from "./Cells";
import { SORT_DIRECTIONS } from "./const";

export default function SortColumn({ columnID, columnType }) {
  const [
    {
      sortInfo: { columnID: sortColumnID, direction: sortDirection },
    },
    dispatch,
  ] = useContext(BoardContext);

  const isSorting = columnID === sortColumnID;
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;

  let fontAwesomeIcon = "sort";
  if (isSorting) {
    fontAwesomeIcon = isAscending ? "caret-up" : "caret-down";
  }

  const sortColumn = () => {
    if (isSorting) {
      if (isAscending) {
        dispatch({ type: "Clear Sort" });
      } else {
        dispatch({
          type: "Set Sort",
          payload: {
            columnID,
            columnType,
            direction: SORT_DIRECTIONS.ASCENDING,
          },
        });
      }
    } else
      dispatch({
        type: "Set Sort",
        payload: {
          columnID,
          columnType,
          direction: SORT_DIRECTIONS.DESCENDING,
        },
      });
  };

  return (
    <Wrapper
      onClick={sortColumn}
      className={isSorting ? `sorted ${sortDirection}` : ""}
    >
      <div className={`fas fa-${fontAwesomeIcon}`} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  left: 12px;
  font-size: 15px;
  width: 24px;
  height: 24px;
  color: #828c8d;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  background: #eceff0;
  box-shadow: #eceff0 0 0 6px;
  opacity: 0;
  visibility: hidden;
  border: 2px solid #eceff0;
  transition: opacity 0.2s, visibility 0.2s, background 0.2s, color 0.2s,
    transform 0.2s;

  &.sorted.asc {
    padding-bottom: 2px;
  }

  ${TitleCellWrapper}:hover:not(:focus-within) &,
  &.sorted {
    opacity: 1;
    visibility: visible;
  }

  &:hover {
    background: #278dc1;
    color: #eceff0;
  }

  &:active {
    transform: scale(0.85);
  }

  &.sorted {
    font-size: 18px;
  }

  &.sorted:not(:hover) {
    color: #278dc1;
  }
`;
